import { ID, Locales } from '@griply/types';
import { getLocalizedStringValue } from '@griply/utils';
import { Goal } from 'shared/types/goal';
import { GoalFormFields } from 'shared/types/goal-form';
import {
  DefaultMetricOptions,
  MetricUnitIds,
} from 'shared/types/metric-template';

export type Options = {
  locale: Locales;
  // Resolved from the goal's relationship document; falls back to the legacy scalar.
  lifeAreaIds?: ID[];
  // Resolved via getGoalParentIds — relationships once migrated, else the frozen chain.
  parentIds?: ID[];
  // A new goal starts on the colour its first link resolves to; the inherit sentinels are retired.
  linkSeedColor?: string | null;
};

export const mapGoalToGoalFields = (
  goal: Partial<Goal>,
  { locale, lifeAreaIds, parentIds, linkSeedColor }: Options,
): GoalFormFields => ({
  name: goal.name,
  description: goal.description ?? null,
  impact: goal.impact ?? null,
  image: goal.image ?? null,
  iconName: goal.iconName ?? null,
  startDate: goal.startDate ?? null,
  deadline: goal.deadline ?? null,
  lifeAreaIds: lifeAreaIds ?? (goal.lifeAreaId ? [goal.lifeAreaId] : []),
  parentIds: parentIds ?? [],
  color: goal.color ?? (goal.id ? null : linkSeedColor ?? null),
  ancestorIds: goal.ancestorIds ?? null,
  metricId: goal.metric?.id ?? null,
  metricStartValue: goal.metric?.startValue ?? null,
  metricTargetValue: goal.metric?.targetValue ?? null,
  metricUnit:
    goal.metric?.id === DefaultMetricOptions.Custom
      ? (goal.metric?.unit?.name &&
          getLocalizedStringValue(goal.metric?.unit.name, locale)) ??
        null
      : goal.metric?.unit?.id === MetricUnitIds.Custom
        ? getLocalizedStringValue(goal.metric.unit.name, locale)
        : goal.metric?.unit?.id ?? null,
});
